/* ==========================================================================
   PDP — STORE, HOURS & STICKY BUTTON (sections/pdp_store.liquid)

   Opens and closes the store panel, and paints its open / closed badge and
   the week's hours from the same table the store card reads
   (the JSON that snippets/pirloni-store-card.liquid prints), on the
   shopper's own clock — so the card and the panel can never disagree.
   ========================================================================== */
(function () {
  'use strict';

  /** "10:00" -> 10.0 ; "9:30" -> 9.5 ; anything else -> null (closed). */
  function toHours(value) {
    if (!value) return null;
    var parts = String(value).split(':');
    var h = parseInt(parts[0], 10);
    if (isNaN(h)) return null;
    var m = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    return h + (isNaN(m) ? 0 : m) / 60;
  }

  function init(root) {
    if (root.getAttribute('data-pdps-ready') === 'true') return;
    root.setAttribute('data-pdps-ready', 'true');

    var sheet = root.querySelector('[data-pdps-sheet]');
    if (!sheet) return;

    var data = null;
    var node = root.querySelector('[data-pst-data]');
    if (node) { try { data = JSON.parse(node.textContent); } catch (e) { data = null; } }
    var days = data && data.days ? data.days : [];

    var badge = sheet.querySelector('[data-pdps-badge]');
    var hours = sheet.querySelector('[data-pdps-hours]');

    // the table is written Monday first; JavaScript counts from Sunday
    function dayIndex(jsDay) { return (jsDay + 6) % 7; }

    function paint() {
      if (!days.length) return;
      var now = new Date();
      var todayRow = dayIndex(now.getDay());
      var current = now.getHours() + now.getMinutes() / 60;
      var today = days[todayRow];
      var openAt = today ? toHours(today.open) : null;
      var closeAt = today ? toHours(today.close) : null;
      var isOpen = openAt !== null && closeAt !== null && current >= openAt && current < closeAt;

      if (badge) {
        badge.classList.toggle('is-shut', !isOpen);
        badge.textContent = isOpen
          ? (badge.getAttribute('data-open') || 'Open now · until [time]').replace('[time]', today.close || '')
          : (badge.getAttribute('data-shut') || 'Closed now');
      }

      if (hours) {
        var closedWord = hours.getAttribute('data-closed-word') || 'Closed';
        hours.innerHTML = days.map(function (day, i) {
          var span = toHours(day.open) === null ? (day.close || closedWord) : day.open + ' — ' + day.close;
          return '<div class="pdps-hr' + (i === todayRow ? ' is-today' : '') + '">' +
            '<span>' + day.name + '</span><span>' + span + '</span></div>';
        }).join('');
      }
    }

    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      paint();
      sheet.classList.add('is-on');
      sheet.setAttribute('aria-hidden', 'false');
      var x = sheet.querySelector('[data-pdps-close]');
      if (x) x.focus();
    }
    function close() {
      sheet.classList.remove('is-on');
      sheet.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.querySelectorAll('[data-pdps-open]').forEach(function (el) {
      el.addEventListener('click', function (event) { event.preventDefault(); open(); });
      if (el.tagName !== 'BUTTON' && el.tagName !== 'A') {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(); }
        });
      }
    });

    // the photographs in the card open the panel too, when the setting is on
    if (root.getAttribute('data-pdps-photos') === 'true') {
      var gallery = root.querySelector('.pst-gal');
      if (gallery) {
        gallery.classList.add('pdps-photos');
        gallery.setAttribute('role', 'button');
        gallery.setAttribute('tabindex', '0');
        gallery.addEventListener('click', open);
        gallery.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(); }
        });
      }
    }

    sheet.querySelectorAll('[data-pdps-close]').forEach(function (b) { b.addEventListener('click', close); });
    sheet.addEventListener('click', function (event) { if (event.target === sheet) close(); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && sheet.classList.contains('is-on')) close();
    });

    paint();
    window.setInterval(paint, 30000);
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-pdps]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
